import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'
import Numeral from 'numeral'
import { getTimezoneDate } from 'utils/date'

import DatePicker from 'material-ui/DatePicker'

import {getMonth} from 'utils/date'
import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.objectID)
	})
)

export class PaymentDate extends Component{
	render(){
		let { props } = this
		return(
				<div style={{margin: "0px", display:"inline-block", width: "20%"}}>
                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
                    Paid date</p>
                    <DatePicker
                        style={{
                            color: "#000"
                        }}
                        textFieldStyle={{
                            fontSize: "16px"
                            , width: "100px"
                            , height: "36px"
                            , color: "#000"
                        }}
                        underlineStyle={{
                            borderBottom: props.transaction.date ? "0px solid" : "0px solid"
                        }}
                        inputStyle={{color: "#000"}}
                        underlineDisabledStyle={{borderBottom: "0px solid"}}
                        hintText="Select"
						formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
                        hintStyle={{top: "8px"}}
                        style={{width: "100px", height: "35px", marginTop: "8px"}}
                        value={(props.transaction.date)?getTimezoneDate(props.transaction.date):""}
						disabled={props.transaction.qbid || props.transaction.qbidNew}
                        onChange={(evt, value)=>
                            props.STAGE({
                                _id: props.objectID
                                , date: value
                            })
                        }
                    />
                </div>
		)
	}
}

export default connect(select, dataActions)(PaymentDate)



// WEBPACK FOOTER //
// ./src/routes/manager/transactionForm/PaymentDate.js